export default __webpack_public_path__ + "static/media/linux.cbb42f21.png";